import React, { useEffect, useState } from "react";
import { getPaynlPinterminals, updatePaynlMerchant } from "../../PaymentProviders/Paynl/PaynlApi";
import cloudStore from "../../../store/CloudStore";
import { CircularProgress, Divider, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import { Autocomplete } from "@material-ui/lab";
import withIntl from "../../../utils/withIntl";

 function PaynlPinterminalSetup(props) {
  const [paynlPinterminal, setPaynlPinterminal] = useState([]);
  const [availablePinterminals, setAvailablePinterminals] = useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  let loading = open && options.length === 0;

  const searchResults = (searchValue) => {
    if (!availablePinterminals) {
      return [];
    }
    if (paynlPinterminal && searchValue.length === 0) {
      let merchant = availablePinterminals.find(
        (merchant) =>
          merchant.id === paynlPinterminal.id
      );
      if (merchant && selectedOption == null) {
        setSelectedOption(merchant);
      }
    }
    return availablePinterminals.reduce((options, option) => {
      if (options.length > 9) {
        return options;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            option.id.toLowerCase().includes(value.toLowerCase()) ||
            option.name.toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        options.push(option);
      }

      return options;
    }, []);
  };

  useEffect(() => {
    getPaynlPinterminals().then((paynlPinterminals) => {
      setAvailablePinterminals(paynlPinterminals.terminals);
    });
  }, []);

  useEffect(() => {
    console.log(selectedOption)
    if (
      selectedOption &&
      paynlPinterminal?.id !== selectedOption.id
    ) {
      props.updatePaynlPinterminal(selectedOption);
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await searchResults(searchValue);
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, availablePinterminals]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  if (!availablePinterminals) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <AuthorizationWrapper
      permission={"paynl.connect_merchant"}
      child={
        <>
          <Divider />
          <Typography variant={"h6"}>Connect new pin terminal</Typography>
          <Autocomplete
            style={{ width: 300 }}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
              setSearchValue("");
            }}
            filterOptions={(x) => x}
            onChange={(e, value) => {
              if (value) {
                setSelectedOption(value);
              }
            }}
            onInputChange={(event, value) => {
              setSearchValue(value);
            }}
            getOptionSelected={(option, value) => {
              return option.id === value.id;
            }}
            getOptionLabel={(option) => option.id + " - " + option.name}
            options={options}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.intl.formatMessage({ id: "Search" })}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </>
      }
    />
  );
}

export default withIntl(PaynlPinterminalSetup)